import styled from "@emotion/styled";
import {
  COLOR_TERTIARY,
  FONT_SIZE_SMALL,
  MOBILE_SCREEN,
  TEXT_FONT_FAMILY,
} from "../../theme";
import { LinkButton } from "../../buttons/LinkButton";
import Link from "../../typography/Link";

export const AttorneyLinkContainer = styled.div<{ isDisabled?: boolean }>`
  pointer-events: ${(props) => (props.isDisabled ? "none" : "auto")};
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  cursor: ${(props) => (props.isDisabled ? "default" : "pointer")};
  width: 100%;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  padding: 24px;
  border-radius: 16px;
  background-color: ${COLOR_TERTIARY};
`;

export const Container = styled.div`
  display: flex;
  gap: 16px;
  ${MOBILE_SCREEN} {
    flex-direction: column;
  }
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const QuestionGroup = styled.div<{ layout: "vertical" | "horizontal" }>`
  display: flex;
  flex-direction: ${({ layout }) =>
    layout === "horizontal" ? "row" : "column"};
  gap: 16px;
  align-items: flex-end;
  ${MOBILE_SCREEN} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Question = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const StyledLinkButton = styled(LinkButton)`
  padding: 0;
  font-weight: 600;
  font-family: ${TEXT_FONT_FAMILY};
  font-size: ${FONT_SIZE_SMALL};
`;

export const MobileSliderContainer = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
`;

export const MobileReviewWrapper = styled.div`
  flex: 0 0 100%;
  scroll-snap-align: start;
  padding: 0 16px;
  box-sizing: border-box;
`;

export const StyledLink = styled(Link)`
  font-weight: 300;
`;
